import { useAppSelector } from 'hooks/redux';
import React, { useState } from 'react';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import ChatIcon from '@mui/icons-material/Chat';
import type { SxProps, Theme } from '@mui/material'; // Import from '@mui/material' instead of '@mui/system'
import Fab from '@mui/material/Fab';

import SimplifiAiAssistant from 'containers/SimplifiAiAssistant';

const isDev =
  window?.location?.hostname !== 'simplifi.quicken.com' && window?.location?.hostname !== 'app.simplifimoney.com';

interface ChatLauncherProps {
  optBotOffset?: number;
  optRightOffset?: number;
  zIndex?: number;
}

const ChatLauncher: React.FC<ChatLauncherProps> = ({
  optBotOffset = 20, // Default value if not provided
  optRightOffset = 20, // Default value if not provided
  zIndex = 1000, // Default value if not provided
}) => {
  const launcherStyles: SxProps<Theme> = {
    position: 'fixed',
    bottom: optBotOffset,
    right: optRightOffset,
    zIndex: zIndex,
  };

  const [showAiAssistant, setShowAiAssistant] = useState(false);

  const ffAiChat = useAppSelector((reduxState) => featureFlagsSelectors.getFeatureFlags(reduxState).get('aiChat'));

  if (isDev && ffAiChat) {
    return (
      <>
        <SimplifiAiAssistant
          visible={showAiAssistant}
          onClose={() => {
            setShowAiAssistant(false);
          }}
        />
        <Fab
          color='primary'
          aria-label='chat'
          onClick={() => {
            setShowAiAssistant(!showAiAssistant);
          }}
          sx={launcherStyles}
        >
          <ChatIcon />
        </Fab>
      </>
    );
  } else {
    return null;
  }
};

export default ChatLauncher;
